__turbopack_context__.v({
  "className": "inter_cf546198-module__z1YStW__className",
  "variable": "inter_cf546198-module__z1YStW__variable",
});
